import React, { useState } from 'react';
import Modal from '../shared/Modal/Modal';
import Button from '../shared/Button/Button';
import {
  FormGroup,
  FormLabel,
  FormInput,
  FormTextarea,
  FormHint,
  FormActions,
  ErrorMessage,
} from '../shared/Form/Form.styles';
import { DetailList, MoneyTag, Notice } from '../../pages/sales/Sales.styles';
import { markPromoterCutPaid } from '../../services/empresaPromoters';
import { cutWeekLabel } from './CutDetailModal';
import { formatMoney } from '../../utils/money';
import { todayInMexico } from '../../utils/dates';

const NOTE_MAX = 500;

// Modal de confirmación de la marca para "Marcar pagado" (reemplaza window.confirm).
// Solo la empresa dueña; no se puede deshacer. `onPaid(cut)` recibe el corte ya pagado.
const MarkPaidModal = ({ cut, onClose, onPaid, onError }) => {
  const today = todayInMexico();
  const [paidDate, setPaidDate] = useState(today);
  const [note, setNote] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const total = Number(cut.totalAmount) || 0;

  const handleConfirm = async (event) => {
    event.preventDefault();
    setError('');
    if (!paidDate) {
      setError('Elige la fecha en que pagaste.');
      return;
    }
    if (paidDate > today) {
      setError('La fecha de pago no puede ser futura.');
      return;
    }
    if (cut.weekStart && paidDate < cut.weekStart) {
      setError('La fecha de pago no puede ser anterior a la semana del corte.');
      return;
    }
    setBusy(true);
    try {
      const body = { paidDate };
      if (note.trim()) body.note = note.trim();
      const data = await markPromoterCutPaid(cut.id, body);
      onPaid(data.cut, data.message);
    } catch (err) {
      if (onError && onError(err)) return;
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <Modal
      title={`¿Marcar el corte #${cut.id} como pagado?`}
      onClose={busy ? null : onClose}
      maxWidth="500px"
      labelledBy="markpaid-title"
    >
      <form onSubmit={handleConfirm}>
        <DetailList style={{ marginBottom: 14 }}>
          {cut.promoter && <div className="row"><dt>Promotor</dt><dd>{cut.promoter.name}</dd></div>}
          <div className="row"><dt>Semana</dt><dd>{cutWeekLabel(cut)}</dd></div>
          <div className="row strong"><dt>Total del corte</dt><dd><MoneyTag>{formatMoney(total)}</MoneyTag></dd></div>
        </DetailList>

        <Notice $warn>
          BokerHub <strong>no mueve dinero</strong>: esto solo deja registrado que <strong>ya le pagaste</strong> al promotor por tu cuenta.
          Después <strong>no se puede deshacer</strong>.
        </Notice>

        {error && <ErrorMessage role="alert">{error}</ErrorMessage>}

        <FormGroup>
          <FormLabel htmlFor="paid-date">Fecha de pago</FormLabel>
          <FormInput
            id="paid-date"
            type="date"
            value={paidDate}
            min={cut.weekStart}
            max={today}
            disabled={busy}
            onChange={(e) => setPaidDate(e.target.value)}
            required
          />
          <FormHint>Hoy es {today.split('-').reverse().join('/')} (hora de México). No puede ser anterior a la semana del corte.</FormHint>
        </FormGroup>

        <FormGroup>
          <FormLabel htmlFor="paid-note">Nota (opcional)</FormLabel>
          <FormTextarea
            id="paid-note"
            rows={3}
            maxLength={NOTE_MAX}
            value={note}
            disabled={busy}
            placeholder="Por ejemplo: transferencia SPEI, referencia 12345"
            onChange={(e) => setNote(e.target.value)}
          />
          <FormHint>{note.length}/{NOTE_MAX}</FormHint>
        </FormGroup>

        <FormActions>
          <Button type="button" variant="ghost" onClick={onClose} disabled={busy}>Cancelar</Button>
          <Button type="submit" disabled={busy}>{busy ? 'Guardando…' : 'Confirmar: ya pagué'}</Button>
        </FormActions>
      </form>
    </Modal>
  );
};

export default MarkPaidModal;
